var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';
import { fontBody } from 'Styles/fonts';
import { bombas_offwhite, black, red, ui_grey80, white } from 'Styles/colors';
import BaseIcon from '../Icons/Icon';
export var Icon = styled(BaseIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var ButtonTag = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  padding: 6px 12px;\n  height: 34px;\n  align-items: center;\n  color: ", ";\n  background: ", ";\n  cursor: ", ";\n  text-transform: capitalize;\n  border: none;\n  white-space: pre;\n  ", ";\n\n  ", " {\n    margin-left: 8px;\n  }\n"], ["\n  display: inline-flex;\n  padding: 6px 12px;\n  height: 34px;\n  align-items: center;\n  color: ", ";\n  background: ", ";\n  cursor: ", ";\n  text-transform: capitalize;\n  border: none;\n  white-space: pre;\n  ", ";\n\n  ", " {\n    margin-left: 8px;\n  }\n"])), switchProp('variant', {
    default: ui_grey80,
    dark: white,
    light: ui_grey80,
    error: white
}), switchProp('variant', {
    default: bombas_offwhite,
    dark: black,
    light: bombas_offwhite,
    error: red
}), ifProp('onClick', 'pointer', 'default'), fontBody(14), Icon);
var templateObject_1, templateObject_2;
